import React, { useEffect, useState } from "react";
import axios from "axios";
import { base_url } from "../Auth/BackendAPIUrl";
import { Questionnaire } from "./Questionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfigToken } from "../Auth/ConfigToken";
import {toast, ToastContainer} from "react-toastify";
import { Toaster } from "react-hot-toast";
import { fetchQuestionAnswer } from "./questionnaire.slice";

import { processArabicText } from "../Utils/arabicFontParenthesisChecker";
import useToastMessage from "../Pages/Toaster/Toaster";
import {capitalStyles, textureImages1} from "../../json/QuestionnaireColorCodes";
import { handleAutoResize } from "./useAutoResize";

export const Questionnaire4 = ({
  formData,
  setFormData,
  changeLang,
  setChangeLang,
  handleBackNavigation,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const answers = useSelector((state) => state.questionnaire3);
  const currentAnswer = useSelector((state) => state.questionnaire4);
  const [isFilled, setIsFilled] = useState(null);
  const [errors, setErrors] = useState({});
    const { showErrorToast } = useToastMessage();

  /* NEW QUESTIONANSWER */

  const questionAndAnswers = useSelector(
    (state) => state?.questionAnswer?.questionAndAnswers || []
  );
  const orderId = useSelector((state) => state?.questionAnswer?.orderId);
    const orderData = useSelector((state) => state?.questionAnswer?.orderData);
  const [questionAnswer4, setQuestionAnswer4] = useState([]);

  useEffect(() => {
    if (questionAndAnswers?.length > 0) {
      setQuestionAnswer4(questionAndAnswers);
    }
  }, [questionAndAnswers]);

  // Helper function to filter out duplicate questions across categories
  const filterDuplicateQuestions = (questions, currentCategory) => {
    const answeredQuestionIds = questionAndAnswers
      .filter(q => {
        const answer = q.answer;
        if (!answer) return false;
        if (typeof answer === "string" && answer.trim() !== "") return true;
        if (Array.isArray(answer) && answer.length > 0) return true;
        if (typeof answer === "object" && !Array.isArray(answer) && Object.keys(answer).length > 0) return true;
        return false;
      })
      .map(q => q.id);

    return questions.filter(q => {
      const isAnswered = answeredQuestionIds.includes(q.id);
      const categories = q.category?.split(',') || [];
      const hasMultipleCategories = categories.length > 1;
      
      if (isAnswered && hasMultipleCategories) {
        const answeredQuestion = questionAndAnswers.find(aq => aq.id === q.id);
        if (answeredQuestion) {
          const answeredCategories = answeredQuestion.category?.split(',') || [];
          return answeredCategories.includes(currentCategory);
        }
      }
      return true;
    });
  };

  const countWords = (str) => {
    if (!str || typeof str !== "string") return 0;
    return str.trim().split(/\s+/).filter((word) => word.length > 0).length;
  };

  /* NEW QUESTIONANSWER */

  useEffect(() => {
    window.onbeforeunload = () => {
      sessionStorage.setItem("isReload", "true");
    };
      document.addEventListener("touchstart", function(){}, true);
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // Detect refresh on mount
  useEffect(() => {
    if (sessionStorage.getItem("isReload") === "true") {
      sessionStorage.removeItem("isReload");
      navigate("/questionnaire/1");
    }
  }, [navigate]);

  const placeHolders = ["BUNDL", "(ex: BUNDL, bundl, Bundl)", "Bundl Designs"];
  const placeHolders_arabic = ["باقة", "(على سبيل المثال: BUNDL، bundl، Bundl)", "تصاميم البوندل"];

  useEffect(() => {
    const fetchAnswers = async () => {
      try {
        if (location?.state?.orderId != undefined) {
          const response = await axios.get(
            `${base_url}/api/questionnaire/update/${location?.state?.orderId}`,
            ConfigToken()
          );
          const answers = response?.data?.data;

          answers.forEach((item) => {
            const { question_id, answer, answer_type } = item;

            setFormData((prevFormData) => ({
              ...prevFormData,
              [question_id]: answer,
            }));
          });
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    setFormData(currentAnswer);
    fetchAnswers();
  }, []);

  const validateFields = () => {
    // Check for word count limit
    const wordLimitExceeded = questionAnswer4.some((q) => {
      if (q.answer_type !== "input") return false;
      return countWords(q.answer) > 70;
    });

    if (wordLimitExceeded) {
      const questionWithLimitError = questionAnswer4.find((q) => {
        if (q.answer_type !== "input") return false;
        return countWords(q.answer) > 70;
      });
      if (questionWithLimitError) {
        setErrors((prev) => ({
          ...prev,
          [questionWithLimitError.id]: changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words",
        }));
        setIsFilled(questionWithLimitError.id);
        const element = document.getElementById(`question_${questionWithLimitError.id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      return false;
    }

    // Filter required questions that are either unanswered or contain invalid data
    // Exclude question id 25 if orderData.language is Arabic
    const unansweredRequiredQuestions = questionAnswer4.
      filter(f => f.category.split(',').includes('naming')).sort((a, b)=> a.sort_order - b.sort_order)
      .filter((q) => {
        // Exclude question id 25 if language is Arabic (case-insensitive check)
        if (q.id === 25 && orderData?.language && orderData.language.toLowerCase() === 'arabic') {
          return false;
        }
        
        const answer = q.answer;
        if (!q.required) {
          return false;
        }

        if (
          answer === undefined ||
          answer === null ||
          (typeof answer === "string" && answer.trim() === "") ||
          (Array.isArray(answer) && answer?.length === 0) ||
          (typeof answer === "object" &&
            !Array.isArray(answer) &&
            Object.keys(answer).length === 0)
        ) {
          return true;
        }

        return false; // Valid answer
      });

    if (unansweredRequiredQuestions?.length > 0) {
      const invalidQuestion = unansweredRequiredQuestions[0];
      const element = document.getElementById(
        `question_${invalidQuestion?.id}`
      );
      setIsFilled(invalidQuestion?.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
        if (!toast.isActive("required-value-toast")) {
            showToastMessage();
        }
      
      return false;
    }
    return true;
  };

    const showToastMessage = () => {
        if (!toast.isActive("required-value-toast")) {
            showErrorToast(
                changeLang === "ar" ? "القيمة مطلوب" : "The Value is required!",
                "#D83D99"
            );
        }
    };

  const handleChange = (questionId, value) => {
    if (countWords(value) > 70) {
      setErrors((prev) => ({
        ...prev,
        [questionId]:
          changeLang === "ar"
            ? "يجب ألا يتجاوز النص 70 كلمة"
            : "Text should not exceed 70 words",
      }));
    } else {
      setErrors((prev) => {
        const updated = { ...prev };
        if (updated[questionId] === (changeLang === "ar" ? "يجب ألا يتجاوز النص 70 كلمة" : "Text should not exceed 70 words")) {
          delete updated[questionId];
        }
        return updated;
      });
    }

    setQuestionAnswer4((prev) =>
      prev.map((ele) =>
        ele.id === questionId
          ? {
              ...ele,
              answer: value,
            }
          : ele
      )
    );
  };

  const onBackClick = async () => {
    dispatch(fetchQuestionAnswer(questionAnswer4));
    if (handleBackNavigation) {
      handleBackNavigation(4);
    } else {
      navigate(`/questionnaire/${3}`);
    }
  };

  const onNextClick = () => {
    if (!validateFields()) {
      return; // Stop execution if validation fails
    }
    dispatch(fetchQuestionAnswer(questionAnswer4));
    navigate(`/questionnaire/${5}`, {
      state: {
        orderId: location?.state?.orderId,
      },
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  let newUpdatedAns = questionAnswer4.map((ele) => {
    return {
      id: ele.id,
      answers: ele.answer,
    };
  });


  const onSaveLaterClick = async () => {
    let data = {
      answers: newUpdatedAns,
      orderId: orderId,
      status: "not submitted",
    };
    try {
      const response = await axios.post(
        `${base_url}/api/questionnaire/create`,
        data,
        ConfigToken()
      );
      if (response.status === 200) {
        navigate("/dashboard", {
          state: {
            orderId: location?.state?.orderId,
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <ToastContainer />
      <Questionnaire
        pageNo={4}
        Qlang={changeLang}
        setQLang={setChangeLang}
        storeAnswers={answers}
        orderId={location.state?.orderId}
        onBackClick={onBackClick}
        onNextClick={onNextClick}
        onSaveLaterClick={onSaveLaterClick}
        formData={formData}
        setFormData={setFormData}
        questions={
          <>
            {/* ${question.id == 21 ?'!text-[22px]':''} */}
            {filterDuplicateQuestions(questionAnswer4?.filter(f => f.category.split(',').includes('naming')), 'naming')
              .filter(q => {
                // Exclude question id 25 if orderData.language is Arabic (case-insensitive check)
                if (q.id === 25 && orderData?.language && orderData.language.toLowerCase() === 'arabic') {
                  return false;
                }
                return true;
              })
              .sort((a, b) => a.sort_order - b.sort_order)?.map((question, index) => (
              <div
                className="questions"
                key={index}
                id={`question_${question.id}`}
              >
                  <p
                      className={`questions-title  xs:w-[90%] sm:w-full md:w-full mx-auto ${
                          index === 0 ? "mt-[1.5%]" : "mt-[2%]"
                      } `}
                  >
                      {changeLang === "ar"
                          ? processArabicText(question?.question_arabic)
                          : question?.question}
                      {question?.required && (
                          <span
                              className={`required-asterisk`}
                              aria-hidden="true"
                          >
                        *
                      </span>
                      )}
                  </p>
                {question?.answer_type === "input" && (
                  <>
                    <textarea
                      placeholder={
                        changeLang === ""
                          ? placeHolders_arabic[index]
                          : placeHolders[index]
                      }
                      value={question.answer}
                      className={`question-input ${
                        isFilled === question?.id
                          ? "border-[#D83D99]  border-b-[2px]"
                          : `${
                              window?.innerWidth <= 475
                                ? "border-b-[1px]"
                                : "border-b-[2px]"
                            } border-black`
                      }`}
                      onChange={(e) => {
                        handleChange(question.id, e.target.value);
                        handleAutoResize(e, 200);
                      }}
                      onInput={(e) => handleAutoResize(e, 200)}
                      rows={1}
                    />
                    <div
                      className={`word-counter ${
                        countWords(question.answer) > 70 ? "limit-exceeded" : ""
                      }`}
                    >
                      {changeLang === "ar" ? "كلمات" : "Words"}:{" "}
                      {countWords(question.answer)} / 70
                    </div>
                    {question.id in errors && (
                      <p className="text-[#D83D99]">{errors[question.id]}</p>
                    )}
                  </>
                )}

                  {question.answer_type === "brand" && (
                      <>
                        <div
                            style={{ display: "flex", gap: "10px", marginBottom: "3%" }}
                        >
                          <button
                              className={`product-btn ${
                                  question?.answer === "arabic" ? "active" : ""
                              }`}
                              onClick={() => {
                                handleChange(
                                    question?.id,
                                    'arabic'
                                );
                              }}
                          >
                            {changeLang === "ar" ? "العربية" : "Arabic"}
                          </button>
                          <button
                              className={`service-btn ${
                                  question?.answer === "english" ? "active" : ""
                              }`}
                              onClick={() =>
                                  handleChange(
                                      question.id,
                                      'english'
                                  )
                              }
                          >
                            {changeLang === "ar" ? "الإنجليزية" : "English"}
                          </button>
                        </div>
                        <div
                            className={`w-[100%] xl:h-[2px] lg:h-[2px] md:h-[2px] sm:h-[2px] xs:h-[1px] ${
                                isFilled === question?.id ? "bg-[#D83D99]" : "bg-black"
                            }`}
                        ></div>
                      </>
                  )}
                  {question?.answer_type === "thumbnail" && (
                      <>
                          <div className="form-group lg:w-[75%] md:w-[100%]">
                              <span className="font-error valid-error text-purple"></span>
                              <ul
                                  style={{display: "grid", gridTemplateColumns: "repeat(3,1fr)"}}
                                  className={`h-list select-btns grid-view padding-top-20 checkbox-btn-img h-list-check`}>
                                  {capitalStyles.map((item, index) => (
                                      <li className="checkbox checkbox-btn !w-full"  key={index}>
                                          <input
                                              type="checkbox"
                                              checked={question?.answer === item.value}
                                              value={item.value}
                                              id={`${question.id}-${item.value.split(' ').join('-')}`}
                                              className="validThis"
                                              onChange={(e) =>
                                                  handleChange(question.id, item.value)
                                              }
                                          ></input>
                                          <label htmlFor={`${question.id}-${item.value.split(' ').join('-')}`} className={'h-48 relative'}>
                                              <figure className="image-container img-animation !h-[80%]"
                                                      onMouseEnter={(e) => {
                                                          if (Array.isArray(item.img)) {
                                                              e.target.parentElement.classList.add('animate')
                                                          }
                                                      }}
                                                      onMouseLeave={(e) => {
                                                          if (Array.isArray(item.img)) {
                                                              e.target.parentElement.classList.remove('animate')
                                                          }
                                                      }}>
                                                  {Array.isArray(item.img) ? item.img.map((d, i) => (
                                                      <img key={i} className={'!object-contain'}
                                                          src={d}
                                                          alt={item.fontStyle}
                                                      ></img>
                                                  )) : <img className={'!object-contain'}
                                                      src={item.img}
                                                      alt={item.fontStyle}
                                                  ></img>}
                                              </figure>
                                              <span className="button-text !text-[16px] absolute bottom-0 w-full">
                              {changeLang === "ar" ? item.fontStyle_arabic : item.fontStyle}
                            </span>
                                          </label>
                                      </li>
                                  ))}
                              </ul>
                          </div>
                          <div
                              style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "column",
                              }}
                          >
                              <p className="lg:text-[24px] md:text-[18px] xs:text-[14px] leading-1 font-[500] lg:mt-[1%] md:mt-[0%] xs:mt-[1%] mb-[.5rem]">
                                  {changeLang === "ar"
                                      ? "غير متأكد ؟ لا بأس!"
                                      : "Not sure ? It's okay!"}
                              </p>
                              <button
                                  className={`lg:mb-[2%] md:mb-[2%] xs:mb-[2%] ${
                                      question?.answer === "surprise"
                                          ? "surprise-active"
                                          : "surprise"
                                  }`}
                                  onClick={() =>
                                      handleChange(question.id, "surprise")
                                  }
                              >
                                  {changeLang === "ar" ? "فاجئني!" : "surprise me !"}
                              </button>
                          </div>
                          <div
                              className={`w-[100%] xl:h-[2px] lg:h-[2px] md:h-[2px] sm:h-[2px] xs:h-[1px] ${
                                  isFilled === question?.id ? "bg-[#D83D99]" : "bg-black"
                              } mt-[3%]`}
                          ></div>
                      </>
                  )}
              </div>
            ))}
          </>
        }
        bgTitle={changeLang === "ar" ? "التسمية والنصوص" : "Naming & Copy"}
      />
    </div>
  );
};
